import {Product} from "../sdk/models";

export class IProduct extends Product {


    public static readonly FIELDS: Array<string> = [
        'id', 'active', 'name', 'uom_id'
    ];
    public static readonly FILTER_INCLUDE:any = {
        "relation": "uom", 
        "scope": {"fields": ["id", "name"]}
    };
    
    public uom: {id: number, name:string};
    
    constructor(json: Product) {
        super(json);
    }

}


// WEBPACK FOOTER //
// ./src/models/iProduct.ts